export default __webpack_public_path__ + "static/media/Chamni Thpmnee.a54ff3c3.jpg";